import { useState } from 'react'
import { DEFAULT_PAGE_SIZE, ListPagination } from '@/components/common/ListPagination'
import { Skeleton } from '@/components/ui/skeleton'
import { ServiceRecordTable } from '@/pages/customers/service-records/components/ServiceRecordTable'
import { useServiceRecords } from '@/hooks/useServiceRecords'

interface CustomerServiceRecordTabProps {
  customerId: number
}

export function CustomerServiceRecordTab({ customerId }: CustomerServiceRecordTabProps) {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
  const { data, isLoading, isError } = useServiceRecords({ page, page_size: pageSize, customer_id: customerId })

  if (isLoading) return <Skeleton className="h-40 w-full" />
  if (isError) return <p className="text-sm text-muted-foreground py-8 text-center">服务记录加载失败</p>

  return (
    <div className="space-y-3">
      <ServiceRecordTable records={data?.list ?? []} showCustomer={false} showActions={false} />
      {(data?.total ?? 0) > 0 && (
        <ListPagination
          total={data?.total ?? 0}
          page={page}
          pageSize={pageSize}
          onPageChange={setPage}
          onPageSizeChange={size => { setPageSize(size); setPage(1) }}
        />
      )}
    </div>
  )
}
